'use strict';

angular.module('ClinicApp').controller('ModalPrimaryPhotoCrop', function($scope, $modalInstance, $q, photo, options) {

  $scope.photo = {
    original: photo,
    cropped: null,
    noCrop: false,
  };

  $scope.options = options;

  $scope.save = function() {
    if ($scope.photo.noCrop) {
      $modalInstance.close($scope.photo.original);
    } else {
      $modalInstance.close($scope.photo.cropped);
    }
    return $q.when();
  };

  $scope.close = function() {
    $modalInstance.dismiss();
  };

});
